import React from 'react';
import MonthlyIssuedListData from './MonthlyIssuedListData';
import MonthlyIssuedListSearch from './MonthlyIssuedListSearch';
import { connect } from 'react-redux';

export const MonthlyIssuedList = ({ isDob = false, username }) => {
  const renderDefault = () => {
    return (
      <>
        <MonthlyIssuedListSearch />
        <MonthlyIssuedListData />
      </>
    );
  };

  const render = () => {
    return renderDefault();
  };

  return (
    <div className='report mx-5'>
      <div className='mt-5'>
        <h3 className='text-primary'>DANH SÁCH HĐ BH DOANH NGHIỆP PHÁT HÀNH TRONG THÁNG</h3>
      </div>
      <div>{render()}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const isDob = state?.auth?.authorities?.map((e) => e.authority)?.includes('ROLE_DOB');
  const username = state?.auth?.name;
  return { isDob, username };
};

export default connect(mapStateToProps)(MonthlyIssuedList);